import { ReactNode } from "react";

import { COSIGNATURE_ACKNOWLEDGEMENT } from "@/features/cosignature/constants";
import { testLocator } from "@/lib/helpers/test-locator";
import type { UUID } from "@/core/types";

import { nameWithCredentials } from "./helpers/name-with-credentials";
import { NoteCosignature } from "./components/NoteCosignature";
import { NoteSignature } from "./components/NoteSignature";
import { ProviderSignature } from "./components/ProviderSignature";

type SignatureListProps = {
  className?: string;
  cosignatureBadge?: ReactNode;
  cosignedBy?: UUID;
  credentials?: string | null;
  isCosignRequired?: boolean;
  isNoteComplete?: boolean;
  providerPractice?: string | null;
  signature?: string | null;
  signatureDate?: string | null;
  testId?: string;
};

export function SignatureList({
  className,
  cosignatureBadge,
  cosignedBy,
  credentials,
  isCosignRequired,
  isNoteComplete,
  providerPractice,
  signature,
  signatureDate,
  testId = "note-footer",
}: SignatureListProps) {
  return (
    <>
      <footer className={className} {...testLocator(testId)}>
        <ul className="tw:flex tw:flex-wrap tw:items-start tw:justify-between tw:gap-4">
          {signature && (
            <NoteSignature label="Signature" {...testLocator("providerSignature")}>
              <ProviderSignature>
                {nameWithCredentials({ credentials, name: signature })}
              </ProviderSignature>
            </NoteSignature>
          )}

          {isCosignRequired && (
            <div className="tw:flex tw:max-w-1/3 tw:flex-col tw:gap-1">
              <NoteCosignature cosignatureBadge={cosignatureBadge} cosignedBy={cosignedBy} />

              {isNoteComplete && (
                <span className="tw:text-sm tw:text-text-tertiary">
                  {COSIGNATURE_ACKNOWLEDGEMENT}
                </span>
              )}
            </div>
          )}

          {signatureDate && <NoteSignature label="Signature Date">{signatureDate}</NoteSignature>}

          {providerPractice && (
            <NoteSignature label="Provider Practice">{providerPractice}</NoteSignature>
          )}
        </ul>
      </footer>
    </>
  );
}
